export const metricOptions = [
    { value: 'Ventas', label: 'Ventas' },
    { value: 'Pedidos', label: 'Pedidos' },
    { value: 'AOV', label: 'AOV' },
    { value: 'Unidades', label: 'Unidades' },
    { value: 'TotalAcumulado', label: 'Total Acumulado' }
];
